import { render, staticRenderFns } from "./InformationForm.vue?vue&type=template&id=23de9594&"
import script from "./InformationForm.vue?vue&type=script&lang=js&"
export * from "./InformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports